// extracted by mini-css-extract-plugin
export default {"form":"f1gubnVuIFv36VHnmEiq","name":"M1raGekTU07pz2IjRqMe","formActions":"vxapI3PLPQtTy406TKxe","formBtn":"xc96BmnzIlH3ayfOFyog","pulse":"KIe5811cCzb1Dw0_fzhv"};